import { memo, type ReactNode } from "react";

import { Tooltip } from "@vega-core/components/Tooltip/Tooltip";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type Props = {
  ariaLabel?: string;
  className?: string;
  content?: ReactNode | string;
  title?: string;
  tooltipContentClassname?: string;
};

export const TooltipInfoIcon = memo(
  ({
    ariaLabel = "info-icon",
    className,
    content,
    title,
    tooltipContentClassname,
  }: Props) => (
    <Tooltip
      className={cnTwMerge(
        "w-full max-w-xs fill-text/primary text-text/primary",
        tooltipContentClassname,
      )}
      clickToOpen
      content={content}
      title={title}
    >
      <svg
        aria-label={ariaLabel}
        className={cnTwMerge(
          "w-4 h-4 min-w-4 min-h-4 cursor-pointer transition-all hover:text-text/primary text-text/secondary",
          className,
        )}
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="7" fill="currentColor" r="1" />
        <path
          d="M11 10H12V17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </svg>
    </Tooltip>
  ),
);
